__turbopack_context__.v({
  "cityBox": "cities-gallery-section-module-scss-module__LP7N8a__cityBox",
  "cityBox_caption": "cities-gallery-section-module-scss-module__LP7N8a__cityBox_caption",
  "cityBox_cityName": "cities-gallery-section-module-scss-module__LP7N8a__cityBox_cityName",
  "cityBox_label": "cities-gallery-section-module-scss-module__LP7N8a__cityBox_label",
  "cityBox_wave": "cities-gallery-section-module-scss-module__LP7N8a__cityBox_wave",
  "cityBox_waveBox": "cities-gallery-section-module-scss-module__LP7N8a__cityBox_waveBox",
  "cityBox_wrapper": "cities-gallery-section-module-scss-module__LP7N8a__cityBox_wrapper",
  "gallery": "cities-gallery-section-module-scss-module__LP7N8a__gallery",
  "gallery_citiesBox": "cities-gallery-section-module-scss-module__LP7N8a__gallery_citiesBox",
});
